import { render, staticRenderFns } from "./Maintainence.vue?vue&type=template&id=013a8bc2&"
import script from "./Maintainence.vue?vue&type=script&lang=js&"
export * from "./Maintainence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports